import { ACTIVITY } from '../vocabulary'
import { DDOS_RESILIENCE, INCIDENT_RESPONSE, PHISHING_SIMULATION, RANSOMWARE_RESILIENCE } from '../app-modules'

const addMonthsToNow = (monthsCount) => {
    const currentDate = new Date()
    currentDate.setMonth(currentDate.getMonth() + monthsCount)
    return currentDate
}

const ddosActivityDemo = {
    id: 1,
    org_id: 1,
    start_date: addMonthsToNow(-2),
    end_date: addMonthsToNow(-1),
    is_complete: false,
    description: `${DDOS_RESILIENCE} ${ACTIVITY}`,
    created_by: 1,
    is_editable: true
}

const incidentResponseActivityDemo = {
    id: 1,
    org_id: 1,
    start_date: addMonthsToNow(1),
    end_date: addMonthsToNow(1),
    is_complete: false,
    description: `${INCIDENT_RESPONSE} ${ACTIVITY}`,
    created_by: 1,
    is_editable: true
}

const phishingSimulationActivityDemo = {
    id: 1,
    org_id: 1,
    start_date: addMonthsToNow(-4),
    end_date: addMonthsToNow(-4),
    is_complete: false,
    description: `${PHISHING_SIMULATION} ${ACTIVITY}`,
    created_by: 1,
    is_editable: true
}

const ransomwareResilienceActivityDemo = {
    id: 1,
    org_id: 1,
    start_date: addMonthsToNow(3),
    end_date: addMonthsToNow(4),
    is_complete: true,
    description: `${RANSOMWARE_RESILIENCE} ${ACTIVITY}`,
    created_by: 1,
    is_editable: true
}

const ddosMetricsDemo = [{
    id: 471,
    activity_id: 12,
    other: 0,
    informational: 3,
    low: 0,
    medium: 8,
    high: 1,
    critical: 0,
    category: 'Total',
    widget: 'Total',
    key: 'Total',
    is_editable: true
}]

const incidentResponseMetricsDemo = [{
    id: 471,
    activity_id: 12,
    other: 0,
    informational: 3,
    low: 0,
    medium: 4,
    high: 12,
    critical: 6,
    category: 'Total',
    widget: 'Total',
    key: 'Total',
    is_editable: true
}]

const phishingSimulationMetricsDemo = [{
    id: 471,
    activity_id: 12,
    other: 0,
    informational: 3,
    low: 0,
    medium: 6,
    high: 4,
    critical: 2,
    category: 'Total',
    widget: 'Total',
    key: 'Total',
    is_editable: true
}]

const ransomwareResilienceMetricsDemo = [{
    id: 471,
    activity_id: 12,
    other: 0,
    informational: 3,
    low: 0,
    medium: 5,
    high: 4,
    critical: 13,
    category: 'Total',
    widget: 'Total',
    key: 'Total',
    is_editable: true
}]

const easmMetricsPlaceholder = [
    {
        id: 1,
        other: '1',
        low: 2,
        medium: 3,
        high: 4,
        very_high: 5,
        critical: 6,
        activity_id: 1,
        category: 'General',
        widget: 'Active',
        key: 'Active',
        is_editable: true
    },
    {
        id: 2,
        other: '7',
        low: 8,
        medium: 9,
        high: 10,
        very_high: 11,
        critical: 12,
        activity_id: 1,
        category: 'General',
        widget: 'Open',
        key: 'Open',
        is_editable: true
    },
    {
        id: 3,
        other: '13',
        low: 14,
        medium: 15,
        high: 16,
        very_high: 17,
        critical: 18,
        activity_id: 1,
        category: 'General',
        widget: 'Acknowledge',
        key: 'Acknowledge',
        is_editable: true
    },
    {
        id: 4,
        other: '19',
        low: 20,
        medium: 21,
        high: 22,
        very_high: 23,
        critical: 24,
        activity_id: 1,
        category: 'General',
        widget: 'Mean Time to Acknowledge',
        key: 'Mean Time to Acknowledge',
        is_editable: true
    },
    {
        id: 5,
        other: '25',
        low: 26,
        medium: 27,
        high: 28,
        very_high: 29,
        critical: 30,
        activity_id: 1,
        category: 'General',
        widget: 'Mean Time to Resolve',
        key: 'Mean Time to Resolve',
        is_editable: true
    },
    {
        id: 6,
        other: '31',
        low: 0,
        medium: 0,
        high: 0,
        very_high: 35,
        critical: 36,
        activity_id: 1,
        category: 'Active',
        widget: 'By Severity',
        key: 'By Severity',
        is_editable: true
    },
    {
        id: 7,
        other: '37',
        low: 38,
        medium: 39,
        high: 40,
        very_high: 41,
        critical: 42,
        activity_id: 1,
        category: 'Active',
        widget: 'By Type',
        key: 'Email Security issue',
        is_editable: true
    },
    {
        id: 8,
        other: '43',
        low: 44,
        medium: 45,
        high: 46,
        very_high: 47,
        critical: 48,
        activity_id: 1,
        category: 'Active',
        widget: 'By Type',
        key: 'Exploitable Ports',
        is_editable: true
    },
    {
        id: 9,
        other: '49',
        low: 50,
        medium: 51,
        high: 52,
        very_high: 53,
        critical: 54,
        activity_id: 1,
        category: 'Active',
        widget: 'By Type',
        key: 'Other',
        is_editable: true
    },
    {
        id: 10,
        other: '55',
        low: 56,
        medium: 57,
        high: 58,
        very_high: 59,
        critical: 60,
        activity_id: 1,
        category: 'By Age',
        widget: 'Acknowledge',
        key: '0-7 d',
        is_editable: true
    },
    {
        id: 11,
        other: '61',
        low: 62,
        medium: 63,
        high: 64,
        very_high: 65,
        critical: 66,
        activity_id: 1,
        category: 'By Age',
        widget: 'Acknowledge',
        key: '8-14 d',
        is_editable: true
    },
    {
        id: 12,
        other: '67',
        low: 68,
        medium: 69,
        high: 70,
        very_high: 71,
        critical: 72,
        activity_id: 1,
        category: 'By Age',
        widget: 'Acknowledge',
        key: '15-31 d',
        is_editable: true
    },
    {
        id: 13,
        other: '73',
        low: 74,
        medium: 75,
        high: 76,
        very_high: 77,
        critical: 78,
        activity_id: 1,
        category: 'By Age',
        widget: 'Acknowledge',
        key: '31 d <',
        is_editable: true
    },
    {
        id: 14,
        other: '79',
        low: 80,
        medium: 81,
        high: 82,
        very_high: 83,
        critical: 84,
        activity_id: 1,
        category: 'By Age',
        widget: 'Open',
        key: '0-7 d',
        is_editable: true
    },
    {
        id: 15,
        other: '85',
        low: 86,
        medium: 87,
        high: 88,
        very_high: 89,
        critical: 90,
        activity_id: 1,
        category: 'By Age',
        widget: 'Open',
        key: '8-14 d',
        is_editable: true
    },
    {
        id: 16,
        other: '91',
        low: 92,
        medium: 93,
        high: 94,
        very_high: 95,
        critical: 96,
        activity_id: 1,
        category: 'By Age',
        widget: 'Open',
        key: '15-31 d',
        is_editable: true
    },
    {
        id: 17,
        other: '97',
        low: 98,
        medium: 99,
        high: 100,
        very_high: 101,
        critical: 102,
        activity_id: 1,
        category: 'By Age',
        widget: 'Open',
        key: '31 d <',
        is_editable: true
    },
    {
        id: 18,
        other: '103',
        low: 104,
        medium: 105,
        high: 106,
        very_high: 107,
        critical: 108,
        activity_id: 1,
        category: 'Findings',
        widget: 'Alerts By Severity',
        key: 'Q2 23',
        is_editable: true
    },
    {
        id: 19,
        other: '109',
        low: 110,
        medium: 111,
        high: 112,
        very_high: 113,
        critical: 114,
        activity_id: 1,
        category: 'Findings',
        widget: 'Alerts By Severity',
        key: 'Q1 23',
        is_editable: true
    },
    {
        id: 20,
        other: '115',
        low: 116,
        medium: 117,
        high: 118,
        very_high: 119,
        critical: 120,
        activity_id: 1,
        category: 'Findings',
        widget: 'Alerts By Severity',
        key: 'Q2 22',
        is_editable: true
    },
    {
        id: 21,
        other: '121',
        low: 122,
        medium: 123,
        high: 124,
        very_high: 125,
        critical: 126,
        activity_id: 1,
        category: 'New Alerts',
        widget: 'By Month',
        key: '01/05/2023',
        is_editable: true
    },
    {
        id: 22,
        other: '27',
        low: 128,
        medium: 129,
        high: 130,
        very_high: 131,
        critical: 132,
        activity_id: 1,
        category: 'Yearly Mean Time',
        widget: 'Acknowledge',
        key: '10/06/2020',
        is_editable: true
    },
    {
        id: 23,
        other: '33',
        low: 134,
        medium: 135,
        high: 136,
        very_high: 137,
        critical: 138,
        activity_id: 1,
        category: 'Yearly Mean Time',
        widget: 'Resolved',
        key: '10/06/2020',
        is_editable: true
    },
    {
        id: 24,
        other: '139',
        low: 140,
        medium: 141,
        high: 142,
        very_high: 143,
        critical: 144,
        activity_id: 1,
        category: 'New Alerts',
        widget: 'By Month',
        key: '01/08/2023',
        is_editable: true
    },
    {
        id: 25,
        other: '145',
        low: 146,
        medium: 147,
        high: 148,
        very_high: 149,
        critical: 150,
        activity_id: 1,
        category: 'New Alerts',
        widget: 'By Month',
        key: '01/06/2023',
        is_editable: true
    },
    {
        id: 26,
        other: '151',
        low: 152,
        medium: 153,
        high: 154,
        very_high: 155,
        critical: 156,
        activity_id: 1,
        category: 'Yearly Mean Time',
        widget: 'Acknowledge',
        key: '01/08/2019',
        is_editable: true
    },
    {
        id: 27,
        other: '157',
        low: 158,
        medium: 159,
        high: 160,
        very_high: 161,
        critical: 162,
        activity_id: 1,
        category: 'Yearly Mean Time',
        widget: 'Resolved',
        key: '01/08/2019',
        is_editable: true
    },
    {
        id: 28,
        other: '63',
        low: 64,
        medium: 65,
        high: 66,
        very_high: 67,
        critical: 68,
        activity_id: 1,
        category: 'Yearly Mean Time',
        widget: 'Acknowledge',
        key: '15/06/2013',
        is_editable: true
    },
    {
        id: 29,
        other: '69',
        low: 70,
        medium: 71,
        high: 72,
        very_high: 73,
        critical: 74,
        activity_id: 1,
        category: 'Yearly Mean Time',
        widget: 'Resolved',
        key: '15/06/2013',
        is_editable: true
    }
]

const qaMetricsPlaceholder = [
    {
        'id': 50,
        'activity_id': 5,
        'category': 'General',
        'widget': 'Cyber Readiness',
        'key': 'Total',
        'not_implemented': 0,
        'partially_implemented': 0,
        'fully_implemented': 90,
        'is_editable': true
    },
    {
        'id': 51,
        'activity_id': 5,
        'category': 'General',
        'widget': 'Scoring By Category',
        'key': 'Technology',
        'not_implemented': 0,
        'partially_implemented': 0,
        'fully_implemented': 65,
        'is_editable': true
    },
    {
        'id': 52,
        'activity_id': 5,
        'category': 'General',
        'widget': 'Scoring By Category',
        'key': 'People',
        'not_implemented': 0,
        'partially_implemented': 0,
        'fully_implemented': 76,
        'is_editable': true
    },
    {
        'id': 53,
        'activity_id': 5,
        'category': 'General',
        'widget': 'Scoring By Category',
        'key': 'Processes',
        'not_implemented': 0,
        'partially_implemented': 0,
        'fully_implemented': 80,
        'is_editable': true
    },
    {
        'id': 54,
        'activity_id': 5,
        'category': 'General',
        'widget': 'Implementation of Security Control',
        'key': 'Chart Percentage',
        'not_implemented': 10,
        'partially_implemented': 40,
        'fully_implemented': 50,
        'is_editable': true
    },
    {
        'id': 55,
        'activity_id': 5,
        'category': 'General',
        'widget': 'Implementation of Security Control',
        'key': 'Chart Values',
        'not_implemented': 20,
        'partially_implemented': 60,
        'fully_implemented': 80,
        'is_editable': true
    },
    {
        'id': 56,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Level of Readiness',
        'key': 'Chart Values',
        'not_implemented': 14,
        'partially_implemented': 36,
        'fully_implemented': 50,
        'is_editable': true
    },
    {
        'id': 57,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'Inventory and Control of Software Assets',
        'not_implemented': 0,
        'partially_implemented': 2,
        'fully_implemented': 2,
        'is_editable': true
    },
    {
        'id': 58,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'Secure Configuration of Enterprise Assets and Software',
        'not_implemented': 2,
        'partially_implemented': 3,
        'fully_implemented': 7,
        'is_editable': true
    },
    {
        'id': 59,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'Data Protection',
        'not_implemented': 4,
        'partially_implemented': 8,
        'fully_implemented': 2,
        'is_editable': true
    },
    {
        'id': 60,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'Audit Log Management',
        'not_implemented': 0,
        'partially_implemented': 5,
        'fully_implemented': 8,
        'is_editable': true
    },
    {
        'id': 61,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'Email and Web Browser Protections',
        'not_implemented': 1,
        'partially_implemented': 2,
        'fully_implemented': 6,
        'is_editable': true
    },
    {
        'id': 62,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'Malware Defenses',
        'not_implemented': 0,
        'partially_implemented': 7,
        'fully_implemented': 7,
        'is_editable': true
    },
    {
        'id': 63,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'Network Infrastructure Management',
        'not_implemented': 8,
        'partially_implemented': 3,
        'fully_implemented': 5,
        'is_editable': true
    },
    {
        'id': 64,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'Network Monitoring and Defense',
        'not_implemented': 1,
        'partially_implemented': 9,
        'fully_implemented': 4,
        'is_editable': true
    },
    {
        'id': 65,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'Application Software Security',
        'not_implemented': 5,
        'partially_implemented': 7,
        'fully_implemented': 0,
        'is_editable': true
    },
    {
        'id': 66,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'Inventory and Control of Enterprise Assets',
        'not_implemented': 1,
        'partially_implemented': 9,
        'fully_implemented': 3,
        'is_editable': true
    },
    {
        'id': 67,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'SOC',
        'not_implemented': 9,
        'partially_implemented': 0,
        'fully_implemented': 1,
        'is_editable': true
    },
    {
        'id': 68,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'Wi-Fi Network',
        'not_implemented': 0,
        'partially_implemented': 8,
        'fully_implemented': 5,
        'is_editable': true
    },
    {
        'id': 69,
        'activity_id': 5,
        'category': 'Technology',
        'widget': 'Readiness by Category',
        'key': 'OT Infrastructures',
        'not_implemented': 0,
        'partially_implemented': 5,
        'fully_implemented': 7,
        'is_editable': true
    },
    {
        'id': 70,
        'activity_id': 5,
        'category': 'People',
        'widget': 'Level of Readiness',
        'key': 'Chart Values',
        'not_implemented': 0,
        'partially_implemented': 60,
        'fully_implemented': 40,
        'is_editable': true
    },
    {
        'id': 71,
        'activity_id': 5,
        'category': 'People',
        'widget': 'Readiness by Category',
        'key': 'Security Awareness and Skills Training',
        'not_implemented': 0,
        'partially_implemented': 2,
        'fully_implemented': 6,
        'is_editable': true
    },
    {
        'id': 72,
        'activity_id': 5,
        'category': 'People',
        'widget': 'Readiness by Category',
        'key': 'Service Provider Management',
        'not_implemented': 6,
        'partially_implemented': 7,
        'fully_implemented': 0,
        'is_editable': true
    },
    {
        'id': 73,
        'activity_id': 5,
        'category': 'People',
        'widget': 'Readiness by Category',
        'key': 'Account Management',
        'not_implemented': 5,
        'partially_implemented': 3,
        'fully_implemented': 3,
        'is_editable': true
    },
    {
        'id': 74,
        'activity_id': 5,
        'category': 'People',
        'widget': 'Readiness by Category',
        'key': 'Access Control Management',
        'not_implemented': 0,
        'partially_implemented': 5,
        'fully_implemented': 3,
        'is_editable': true
    },
    {
        'id': 75,
        'activity_id': 5,
        'category': 'Processes',
        'widget': 'Level of Readiness',
        'key': 'Chart Values',
        'not_implemented': 7,
        'partially_implemented': 30,
        'fully_implemented': 70,
        'is_editable': true
    },
    {
        'id': 76,
        'activity_id': 5,
        'category': 'Processes',
        'widget': 'Readiness by Category',
        'key': 'Continuous Vulnerability Management',
        'not_implemented': 0,
        'partially_implemented': 1,
        'fully_implemented': 2,
        'is_editable': true
    },
    {
        'id': 77,
        'activity_id': 5,
        'category': 'Processes',
        'widget': 'Readiness by Category',
        'key': 'Data Recovery',
        'not_implemented': 1,
        'partially_implemented': 2,
        'fully_implemented': 3,
        'is_editable': true
    },
    {
        'id': 78,
        'activity_id': 5,
        'category': 'Processes',
        'widget': 'Readiness by Category',
        'key': 'Incident Response Management',
        'not_implemented': 3,
        'partially_implemented': 2,
        'fully_implemented': 6,
        'is_editable': true
    },
    {
        'id': 79,
        'activity_id': 5,
        'category': 'Processes',
        'widget': 'Readiness by Category',
        'key': 'Penetration Testing',
        'not_implemented': 1,
        'partially_implemented': 4,
        'fully_implemented': 2,
        'is_editable': true
    },
    {
        'id': 80,
        'activity_id': 5,
        'category': 'Processes',
        'widget': 'Readiness by Category',
        'key': 'Human resources (HR) security aspects',
        'not_implemented': 0,
        'partially_implemented': 3,
        'fully_implemented': 5,
        'is_editable': true
    },
    {
        'id': 81,
        'activity_id': 5,
        'category': 'Processes',
        'widget': 'Readiness by Category',
        'key': 'Physical security',
        'not_implemented': 0,
        'partially_implemented': 6,
        'fully_implemented': 6,
        'is_editable': true
    },
    {
        'id': 82,
        'activity_id': 5,
        'category': 'Processes',
        'widget': 'Readiness by Category',
        'key': 'Business Continuity Planning',
        'not_implemented': 0,
        'partially_implemented': 7,
        'fully_implemented': 0,
        'is_editable': true
    }
]

const redTeamMetricsPlaceholder = [
    {
        'id': 1,
        'activity_id': 1,
        'other': 0,
        'informational': 1,
        'low': 1,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk Level By Category',
        'widget': 'Radar',
        'key': 'Chain of the Attack',
        'is_editable': true
    },
    {
        'id': 2,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 4,
        'high': 3,
        'critical': 1,
        'category': 'Risk Level By Category',
        'widget': 'Radar',
        'key': 'Breaching the Internal Perimeter',
        'is_editable': true
    },
    {
        'id': 3,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 4,
        'critical': 1,
        'category': 'Risk Level By Category',
        'widget': 'Radar',
        'key': 'Internal Attack',
        'is_editable': true
    },
    {
        'id': 4,
        'activity_id': 1,
        'other': 0,
        'informational': 4,
        'low': 0,
        'medium': 2,
        'high': 1,
        'critical': 0,
        'category': 'Risk Level By Category',
        'widget': 'Radar',
        'key': 'External Attack',
        'is_editable': true
    },
    {
        'id': 5,
        'activity_id': 1,
        'other': 0,
        'informational': 5,
        'low': 3,
        'medium': 0,
        'high': 1,
        'critical': 1,
        'category': 'Risk Level By Category',
        'widget': 'Radar',
        'key': 'Application PT',
        'is_editable': true
    },
    {
        'id': 6,
        'activity_id': 1,
        'other': 0,
        'informational': 2,
        'low': 2,
        'medium': 3,
        'high': 1,
        'critical': 5,
        'category': 'Risk Level By Category',
        'widget': 'Radar',
        'key': 'Infrastructure PT',
        'is_editable': true
    },
    {
        'id': 7,
        'activity_id': 1,
        'other': 2,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Findings',
        'widget': 'By Category',
        'key': 'Chain of the Attack',
        'is_editable': true
    },
    {
        'id': 8,
        'activity_id': 1,
        'other': 8,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Findings',
        'widget': 'By Category',
        'key': 'Breaching the Internal Perimeter',
        'is_editable': true
    },
    {
        'id': 9,
        'activity_id': 1,
        'other': 5,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Findings',
        'widget': 'By Category',
        'key': 'Internal Attack',
        'is_editable': true
    },
    {
        'id': 13,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 9,
        'high': 10,
        'critical': 8,
        'category': 'Findings',
        'widget': 'By Impact',
        'key': 'By Impact',
        'is_editable': false
    },
    {
        'id': 14,
        'activity_id': 1,
        'other': 0,
        'informational': 10,
        'low': 5,
        'medium': 10,
        'high': 0,
        'critical': 5,
        'category': 'Findings',
        'widget': 'By Severity',
        'key': 'By Severity',
        'is_editable': false
    },
    {
        'id': 15,
        'activity_id': 1,
        'other': 0,
        'informational': 20,
        'low': 7,
        'medium': 10,
        'high': 15,
        'critical': 1,
        'category': 'Findings Severity',
        'widget': 'By Quarter',
        'key': 'Q1 22',
        'is_editable': true
    },
    {
        'id': 16,
        'activity_id': 1,
        'other': 0,
        'informational': 10,
        'low': 5,
        'medium': 10,
        'high': 0,
        'critical': 5,
        'category': 'Findings Severity',
        'widget': 'By Quarter',
        'key': 'Q2 22',
        'is_editable': true
    },
    {
        'id': 17,
        'activity_id': 1,
        'other': 0,
        'informational': 16,
        'low': 14,
        'medium': 20,
        'high': 0,
        'critical': 0,
        'category': 'Findings Severity',
        'widget': 'By Quarter',
        'key': 'Q1 23',
        'is_editable': true
    },
    {
        'id': 18,
        'activity_id': 1,
        'other': 0,
        'informational': 12,
        'low': 10,
        'medium': 19,
        'high': 3,
        'critical': 0,
        'category': 'Findings Severity',
        'widget': 'By Quarter',
        'key': 'Q2 23',
        'is_editable': true
    },
    {
        'id': 19,
        'activity_id': 1,
        'other': 0,
        'informational': 7,
        'low': 10,
        'medium': 10,
        'high': 0,
        'critical': 0,
        'category': 'Risk Level Trend',
        'widget': 'By Quarter',
        'key': 'Q3 22',
        'is_editable': true
    },
    {
        'id': 20,
        'activity_id': 1,
        'other': 0,
        'informational': 10,
        'low': 7,
        'medium': 8,
        'high': 0,
        'critical': 1,
        'category': 'Risk Level Trend',
        'widget': 'By Quarter',
        'key': 'Q4 22',
        'is_editable': true
    },
    {
        'id': 21,
        'activity_id': 1,
        'other': 0,
        'informational': 15,
        'low': 8,
        'medium': 5,
        'high': 5,
        'critical': 0,
        'category': 'Risk Level Trend',
        'widget': 'By Quarter',
        'key': 'Q1 23',
        'is_editable': true
    },
    {
        'id': 22,
        'activity_id': 1,
        'other': 0,
        'informational': 13,
        'low': 9,
        'medium': 3,
        'high': 2,
        'critical': 2,
        'category': 'Risk Level Trend',
        'widget': 'By Quarter',
        'key': 'Q2 23',
        'is_editable': true
    },
    {
        'id': 23,
        'activity_id': 1,
        'other': 20,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Chain of the Attack',
        'key': '2021',
        'is_editable': true
    },
    {
        'id': 24,
        'activity_id': 1,
        'other': 10,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Chain of the Attack',
        'key': '2022',
        'is_editable': true
    },
    {
        'id': 25,
        'activity_id': 1,
        'other': 5,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Chain of the Attack',
        'key': '2023',
        'is_editable': true
    },
    {
        'id': 26,
        'activity_id': 1,
        'other': 15,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Internal Attack',
        'key': '2021',
        'is_editable': true
    },
    {
        'id': 27,
        'activity_id': 1,
        'other': 10,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Internal Attack',
        'key': '2022',
        'is_editable': true
    },
    {
        'id': 28,
        'activity_id': 1,
        'other': 5,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Internal Attack',
        'key': '2023',
        'is_editable': true
    },
    {
        'id': 29,
        'activity_id': 1,
        'other': 9,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'External Attack',
        'key': '2021',
        'is_editable': true
    },
    {
        'id': 30,
        'activity_id': 1,
        'other': 6,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'External Attack',
        'key': '2022',
        'is_editable': true
    },
    {
        'id': 31,
        'activity_id': 1,
        'other': 3,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'External Attack',
        'key': '2023',
        'is_editable': true
    },
    {
        'id': 32,
        'activity_id': 1,
        'other': 6,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Application PT',
        'key': '2021',
        'is_editable': true
    },
    {
        'id': 33,
        'activity_id': 1,
        'other': 10,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Application PT',
        'key': '2022',
        'is_editable': true
    },
    {
        'id': 34,
        'activity_id': 1,
        'other': 15,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Application PT',
        'key': '2023',
        'is_editable': true
    },
    {
        'id': 35,
        'activity_id': 1,
        'other': 10,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Infrastructure PT',
        'key': '2021',
        'is_editable': true
    },
    {
        'id': 36,
        'activity_id': 1,
        'other': 10,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Infrastructure PT',
        'key': '2022',
        'is_editable': true
    },
    {
        'id': 37,
        'activity_id': 1,
        'other': 7,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Infrastructure PT',
        'key': '2023',
        'is_editable': true
    },
    {
        'id': 38,
        'activity_id': 1,
        'other': 8,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Breaching the Internal Perimeter',
        'key': '2021',
        'is_editable': true
    },
    {
        'id': 39,
        'activity_id': 1,
        'other': 14,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Breaching the Internal Perimeter',
        'key': '2022',
        'is_editable': true
    },
    {
        'id': 40,
        'activity_id': 1,
        'other': 5,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Category By Year',
        'widget': 'Breaching the Internal Perimeter',
        'key': '2023',
        'is_editable': true
    }
]

const penTestMetricsPlaceholder = [
    {
        'id': 1,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 10,
        'medium': 8,
        'high': 5,
        'critical': 3,
        'category': 'Vulnerabilities Totals by Severity',
        'widget': 'Cards',
        'key': 'By Severity',
        'is_editable': true
    },
    {
        'id': 3,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 2,
        'medium': 2,
        'high': 3,
        'critical': 1,
        'category': 'Vulnerabilities by Risk Level',
        'widget': 'Area',
        'key': 'Network Discovery',
        'is_editable': true
    },
    {
        'id': 4,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 1,
        'medium': 2,
        'high': 2,
        'critical': 0,
        'category': 'Vulnerabilities by Risk Level',
        'widget': 'Area',
        'key': 'Application Security Testing',
        'is_editable': true
    },
    {
        'id': 5,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 3,
        'medium': 1,
        'high': 0,
        'critical': 0,
        'category': 'Vulnerabilities by Risk Level',
        'widget': 'Area',
        'key': 'DR Configuration',
        'is_editable': true
    },
    {
        'id': 6,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 4,
        'medium': 3,
        'high': 0,
        'critical': 2,
        'category': 'Vulnerabilities by Risk Level',
        'widget': 'Area',
        'key': 'Operating System Testing',
        'is_editable': true
    },
    {
        'id': 7,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 2,
        'high': 0,
        'critical': 0,
        'category': 'Vulnerabilities by Risk Level',
        'widget': 'Area',
        'key': 'Misconfigurations',
        'is_editable': true
    },
    {
        'id': 8,
        'activity_id': 1,
        'other': 8,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Top 5 Vulnerabilities Categories',
        'widget': 'By Category',
        'key': 'Network Discovery',
        'is_editable': true
    },
    {
        'id': 9,
        'activity_id': 1,
        'other': 5,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Top 5 Vulnerabilities Categories',
        'widget': 'By Category',
        'key': 'Application Security Testing',
        'is_editable': true
    },
    {
        'id': 10,
        'activity_id': 1,
        'other': 4,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Top 5 Vulnerabilities Categories',
        'widget': 'By Category',
        'key': 'DR Configuration',
        'is_editable': true
    },
    {
        'id': 11,
        'activity_id': 1,
        'other': 9,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Top 5 Vulnerabilities Categories',
        'widget': 'By Category',
        'key': 'Operating System Testing',
        'is_editable': true
    },
    {
        'id': 12,
        'activity_id': 1,
        'other': 2,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Top 5 Vulnerabilities Categories',
        'widget': 'By Category',
        'key': 'Misconfigurations',
        'is_editable': true
    },
    {
        'id': 13,
        'activity_id': 1,
        'other': 5,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Vulnerabilities by Status',
        'widget': 'Open',
        'key': 'Open',
        'is_editable': true
    },
    {
        'id': 14,
        'activity_id': 1,
        'other': 10,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Vulnerabilities by Status',
        'widget': 'Resolved',
        'key': 'Resolved',
        'is_editable': true
    },
    {
        'id': 15,
        'activity_id': 1,
        'other': 8,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Vulnerabilities by Status',
        'widget': 'Acknowledge',
        'key': 'Acknowledge',
        'is_editable': true
    },
    {
        'id': 16,
        'activity_id': 1,
        'other': 0,
        'informational': 10,
        'low': 5,
        'medium': 16,
        'high': 7,
        'critical': 1,
        'category': 'Vulnerabilities by Severity',
        'widget': 'By Quarter',
        'key': 'Q1 22',
        'is_editable': true
    },
    {
        'id': 17,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 12,
        'medium': 12,
        'high': 6,
        'critical': 3,
        'category': 'Vulnerabilities by Severity',
        'widget': 'By Quarter',
        'key': 'Q2 22',
        'is_editable': true
    },
    {
        'id': 18,
        'activity_id': 1,
        'other': 0,
        'informational': 10,
        'low': 5,
        'medium': 15,
        'high': 7,
        'critical': 1,
        'category': 'Vulnerabilities by Severity',
        'widget': 'By Quarter',
        'key': 'Q1 23',
        'is_editable': true
    },
    {
        'id': 19,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 10,
        'medium': 10,
        'high': 5,
        'critical': 3,
        'category': 'Vulnerabilities by Severity',
        'widget': 'By Quarter',
        'key': 'Q2 23',
        'is_editable': true
    },
    {
        'id': 20,
        'activity_id': 1,
        'other': 0,
        'informational': 10,
        'low': 5,
        'medium': 16,
        'high': 7,
        'critical': 1,
        'category': 'Risk Level Trend',
        'widget': 'By Quarter',
        'key': 'Q1 22',
        'is_editable': true
    },
    {
        'id': 21,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 2,
        'high': 0,
        'critical': 0,
        'category': 'Risk Level Trend',
        'widget': 'By Quarter',
        'key': 'Q2 22',
        'is_editable': true
    },
    {
        'id': 22,
        'activity_id': 1,
        'other': 0,
        'informational': 10,
        'low': 5,
        'medium': 15,
        'high': 7,
        'critical': 1,
        'category': 'Risk Level Trend',
        'widget': 'By Quarter',
        'key': 'Q1 23',
        'is_editable': true
    },
    {
        'id': 23,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 2,
        'high': 0,
        'critical': 0,
        'category': 'Risk Level Trend',
        'widget': 'By Quarter',
        'key': 'Q2 23',
        'is_editable': true
    },
    {
        'id': 24,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 2,
        'medium': 2,
        'high': 3,
        'critical': 1,
        'category': 'Vulnerabilities Category by Severity',
        'widget': 'Category By Severity',
        'key': 'Network Discovery',
        'is_editable': true
    },
    {
        'id': 25,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 1,
        'medium': 2,
        'high': 2,
        'critical': 0,
        'category': 'Vulnerabilities Category by Severity',
        'widget': 'Category By Severity',
        'key': 'Application Security Testing',
        'is_editable': true
    },
    {
        'id': 26,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 3,
        'medium': 1,
        'high': 0,
        'critical': 0,
        'category': 'Vulnerabilities Category by Severity',
        'widget': 'Category By Severity',
        'key': 'DR Configuration',
        'is_editable': true
    },
    {
        'id': 27,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 4,
        'medium': 3,
        'high': 0,
        'critical': 2,
        'category': 'Vulnerabilities Category by Severity',
        'widget': 'Category By Severity',
        'key': 'Operating System Testing',
        'is_editable': true
    },
    {
        'id': 28,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 2,
        'high': 0,
        'critical': 0,
        'category': 'Vulnerabilities Category by Severity',
        'widget': 'Category By Severity',
        'key': 'Misconfigurations',
        'is_editable': true
    },
    {
        'id': 2,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 6,
        'high': 3,
        'critical': 4,
        'category': 'Vulnerabilities by Risk Level',
        'widget': 'Pie',
        'key': 'By Risk',
        'is_editable': true
    }
]

const ddosMetricsPlaceholder = [
    {
        'id': 50,
        'activity_id': 3,
        'other': 0,
        'none': 1,
        'low': 1,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Exposure By Layer',
        'widget': 'Cylinder',
        'key': 'Physical Layer (Layer 1)',
        'is_editable': false
    },
    {
        'id': 51,
        'activity_id': 3,
        'other': 0,
        'none': 0,
        'low': 0,
        'medium': 4,
        'high': 3,
        'critical': 1,
        'recommendations': null,
        'category': 'Exposure By Layer',
        'widget': 'Cylinder',
        'key': 'Data Link Layer (Layer 2)',
        'is_editable': false
    },
    {
        'id': 52,
        'activity_id': 3,
        'other': 0,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 4,
        'critical': 1,
        'recommendations': null,
        'category': 'Exposure By Layer',
        'widget': 'Cylinder',
        'key': 'Network Layer (Layer 3)',
        'is_editable': false
    },
    {
        'id': 53,
        'activity_id': 3,
        'other': 0,
        'none': 4,
        'low': 0,
        'medium': 2,
        'high': 1,
        'critical': 0,
        'recommendations': null,
        'category': 'Exposure By Layer',
        'widget': 'Cylinder',
        'key': 'Transport Layer (Layer 4)',
        'is_editable': false
    },
    {
        'id': 54,
        'activity_id': 3,
        'other': 0,
        'none': 5,
        'low': 3,
        'medium': 0,
        'high': 1,
        'critical': 1,
        'recommendations': null,
        'category': 'Exposure By Layer',
        'widget': 'Cylinder',
        'key': 'Session Layer (Layer 5)',
        'is_editable': false
    },
    {
        'id': 55,
        'activity_id': 3,
        'other': 0,
        'none': 2,
        'low': 2,
        'medium': 3,
        'high': 1,
        'critical': 5,
        'recommendations': null,
        'category': 'Exposure By Layer',
        'widget': 'Cylinder',
        'key': 'Presentation Layer (Layer 6)',
        'is_editable': false
    },
    {
        'id': 56,
        'activity_id': 3,
        'other': 0,
        'none': 2,
        'low': 2,
        'medium': 3,
        'high': 1,
        'critical': 5,
        'recommendations': null,
        'category': 'Exposure By Layer',
        'widget': 'Cylinder',
        'key': 'Application Layer (Layer 7)',
        'is_editable': false
    },
    {
        'id': 57,
        'activity_id': 3,
        'other': 2,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Findings',
        'widget': 'By Mitigation',
        'key': 'Mitigated',
        'is_editable': false
    },
    {
        'id': 58,
        'activity_id': 3,
        'other': 8,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Findings',
        'widget': 'By Mitigation',
        'key': 'Partially Mitigated',
        'is_editable': false
    },
    {
        'id': 59,
        'activity_id': 3,
        'other': 8,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Findings',
        'widget': 'By Mitigation',
        'key': 'Unmitigated',
        'is_editable': false
    },
    {
        'id': 60,
        'activity_id': 3,
        'other': 1,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Findings',
        'widget': 'By Attack Vectors',
        'key': 'ICMP FLood',
        'is_editable': true
    },
    {
        'id': 61,
        'activity_id': 3,
        'other': 2,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Findings',
        'widget': 'By Attack Vectors',
        'key': 'TCP Flood',
        'is_editable': true
    },
    {
        'id': 62,
        'activity_id': 3,
        'other': 1,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Findings',
        'widget': 'By Attack Vectors',
        'key': 'Slow POST',
        'is_editable': true
    },
    // {
    //     'id': 63,
    //     'activity_id': 3,
    //     'other': 3,
    //     'none': 0,
    //     'low': 0,
    //     'medium': 0,
    //     'high': 0,
    //     'critical': 0,
    //     'recommendations': null,
    //     'category': 'Findings',
    //     'widget': 'By Attack Vectors',
    //     'key': 'SSL Renegotiation',
    //     'is_editable': true
    // },
    // {
    //     'id': 64,
    //     'activity_id': 3,
    //     'other': 1,
    //     'none': 0,
    //     'low': 0,
    //     'medium': 0,
    //     'high': 0,
    //     'critical': 0,
    //     'recommendations': null,
    //     'category': 'Findings',
    //     'widget': 'By Attack Vectors',
    //     'key': 'TCP Syn Flood',
    //     'is_editable': true
    // },
    // {
    //     'id': 65,
    //     'activity_id': 3,
    //     'other': 0,
    //     'none': 0,
    //     'low': 0,
    //     'medium': 0,
    //     'high': 0,
    //     'critical': 0,
    //     'recommendations': null,
    //     'category': 'Findings',
    //     'widget': 'By Attack Vectors',
    //     'key': 'Get Flood to Non-Existing Endpoint',
    //     'is_editable': true
    // },
    // {
    //     'id': 66,
    //     'activity_id': 3,
    //     'other': 1,
    //     'none': 0,
    //     'low': 0,
    //     'medium': 0,
    //     'high': 0,
    //     'critical': 0,
    //     'recommendations': null,
    //     'category': 'Findings',
    //     'widget': 'By Attack Vectors',
    //     'key': 'LOGIN Flood',
    //     'is_editable': true
    // },
    // {
    //     'id': 67,
    //     'activity_id': 3,
    //     'other': 3,
    //     'none': 0,
    //     'low': 0,
    //     'medium': 0,
    //     'high': 0,
    //     'critical': 0,
    //     'recommendations': null,
    //     'category': 'Findings',
    //     'widget': 'By Attack Vectors',
    //     'key': 'Get Flood',
    //     'is_editable': true
    // },
    {
        'id': 68,
        'activity_id': 3,
        'other': 2,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Findings',
        'widget': 'By Attack Types',
        'key': 'Infrastructure',
        'is_editable': false
    },
    {
        'id': 69,
        'activity_id': 3,
        'other': 8,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Findings',
        'widget': 'By Attack Types',
        'key': 'Volumetric',
        'is_editable': false
    },
    {
        'id': 70,
        'activity_id': 3,
        'other': 5,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Findings',
        'widget': 'By Attack Types',
        'key': 'Application',
        'is_editable': false
    },
    {
        'id': 71,
        'activity_id': 3,
        'other': 0,
        'none': 0,
        'low': 10,
        'medium': 10,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Exposure Trends Over Time',
        'widget': 'By Quarter',
        'key': 'Q4 22',
        'is_editable': true
    },
    {
        'id': 72,
        'activity_id': 3,
        'other': 0,
        'none': 0,
        'low': 7,
        'medium': 8,
        'high': 0,
        'critical': 1,
        'recommendations': null,
        'category': 'Exposure Trends Over Time',
        'widget': 'By Quarter',
        'key': 'Q3 23',
        'is_editable': true
    },
    {
        'id': 73,
        'activity_id': 3,
        'other': 0,
        'none': 0,
        'low': 8,
        'medium': 5,
        'high': 5,
        'critical': 0,
        'recommendations': null,
        'category': 'Exposure Trends Over Time',
        'widget': 'By Quarter',
        'key': 'Q4 23',
        'is_editable': true
    },
    {
        'id': 74,
        'activity_id': 3,
        'other': 5,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Attack Vectors Prioritized',
        'widget': 'By # of Vulnerable Targets ',
        'key': 'ICMP FLood',
        'is_editable': true
    },
    {
        'id': 75,
        'activity_id': 3,
        'other': 9,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Attack Vectors Prioritized',
        'widget': 'By # of Vulnerable Targets ',
        'key': 'TCP Flood',
        'is_editable': true
    },
    {
        'id': 76,
        'activity_id': 3,
        'other': 6,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Attack Vectors Prioritized',
        'widget': 'By # of Vulnerable Targets ',
        'key': 'Slow POST',
        'is_editable': true
    },
    {
        'id': 77,
        'activity_id': 3,
        'other': 7,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Attack Vectors Prioritized',
        'widget': 'By # of Vulnerable Targets ',
        'key': 'SSL Renegotiation',
        'is_editable': true
    },
    {
        'id': 78,
        'activity_id': 3,
        'other': 4,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Attack Vectors Prioritized',
        'widget': 'By # of Vulnerable Targets ',
        'key': 'TCP Syn Flood',
        'is_editable': true
    },
    {
        'id': 79,
        'activity_id': 3,
        'other': 9,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Attack Vectors Prioritized',
        'widget': 'By # of Vulnerable Targets ',
        'key': 'Get Flood to Non-Existing Endpoint',
        'is_editable': true
    },
    {
        'id': 80,
        'activity_id': 3,
        'other': 6,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Attack Vectors Prioritized',
        'widget': 'By # of Vulnerable Targets ',
        'key': 'LOGIN Flood',
        'is_editable': true
    },
    {
        'id': 81,
        'activity_id': 3,
        'other': 8,
        'none': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'recommendations': null,
        'category': 'Attack Vectors Prioritized',
        'widget': 'By # of Vulnerable Targets ',
        'key': 'Get Flood',
        'is_editable': true
    }
]

const riskAssessmentMetricsPlaceholder = [
    {
        'id': 1,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 9,
        'medium': 8,
        'high': 7,
        'critical': 2,
        'category': 'Risk Level',
        'widget': 'Pie',
        'key': 'By Risk',
        'is_editable': false
    },
    {
        'id': 2,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 2,
        'medium': 4,
        'high': 5,
        'critical': 0,
        'category': 'Risk Matrix',
        'widget': 'Likelihood',
        'key': 'Very likely',
        'is_editable': true
    },
    {
        'id': 3,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 3,
        'medium': 1,
        'high': 1,
        'critical': 0,
        'category': 'Risk Matrix',
        'widget': 'Likelihood',
        'key': 'Likely',
        'is_editable': true
    },
    {
        'id': 4,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 4,
        'medium': 3,
        'high': 1,
        'critical': 0,
        'category': 'Risk Matrix',
        'widget': 'Likelihood',
        'key': 'Occasional',
        'is_editable': true
    },
    {
        'id': 5,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 7,
        'medium': 3,
        'high': 1,
        'critical': 0,
        'category': 'Risk Matrix',
        'widget': 'Likelihood',
        'key': 'Rare',
        'is_editable': true
    },
    {
        'id': 22,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Hardening Review - MacOS',
        'key': 'Vulnerability Management',
        'is_editable': true
    },
    {
        'id': 26,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Hardening Review - MacOS',
        'key': 'Data Protection',
        'is_editable': true
    },
    {
        'id': 27,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Hardening Review - Windows',
        'key': 'Vulnerability Management',
        'is_editable': true
    },
    {
        'id': 34,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Response',
        'widget': 'Hardening Review - MacOS',
        'key': 'Avoid',
        'is_editable': true
    },
    {
        'id': 38,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Response',
        'widget': 'Hardening Review - Windows',
        'key': 'Avoid',
        'is_editable': true
    },
    {
        'id': 6,
        'activity_id': 1,
        'other': 4,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk Status',
        'widget': 'Risk Status',
        'key': 'In Process',
        'is_editable': true
    },
    {
        'id': 7,
        'activity_id': 1,
        'other': 5,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk Status',
        'widget': 'Risk Status',
        'key': 'Pending',
        'is_editable': true
    },
    {
        'id': 8,
        'activity_id': 1,
        'other': 10,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk Status',
        'widget': 'Risk Status',
        'key': 'Approval',
        'is_editable': true
    },
    {
        'id': 9,
        'activity_id': 1,
        'other': 8,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk Status',
        'widget': 'Risk Status',
        'key': 'Denied',
        'is_editable': true
    },
    {
        'id': 10,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk by Category',
        'widget': 'By Category',
        'key': 'Vulnerability Management',
        'is_editable': true
    },
    {
        'id': 11,
        'activity_id': 1,
        'other': 11,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk by Category',
        'widget': 'By Category',
        'key': 'Network Security',
        'is_editable': true
    },
    {
        'id': 12,
        'activity_id': 1,
        'other': 5,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk by Category',
        'widget': 'By Category',
        'key': 'Access Control',
        'is_editable': true
    },
    {
        'id': 13,
        'activity_id': 1,
        'other': 9,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk by Category',
        'widget': 'By Category',
        'key': 'Monitoring and Logging',
        'is_editable': true
    },
    {
        'id': 14,
        'activity_id': 1,
        'other': 2,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk by Category',
        'widget': 'By Category',
        'key': 'Data Protection',
        'is_editable': true
    },
    {
        'id': 15,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk Response',
        'widget': 'Response',
        'key': 'Avoid',
        'is_editable': true
    },
    {
        'id': 16,
        'activity_id': 1,
        'other': 11,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk Response',
        'widget': 'Response',
        'key': 'Mitigate',
        'is_editable': true
    },
    {
        'id': 17,
        'activity_id': 1,
        'other': 5,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk Response',
        'widget': 'Response',
        'key': 'Transfer',
        'is_editable': true
    },
    {
        'id': 18,
        'activity_id': 1,
        'other': 10,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Risk Response',
        'widget': 'Response',
        'key': 'Accept',
        'is_editable': true
    },
    {
        'id': 19,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 1,
        'medium': 1,
        'high': 1,
        'critical': 0,
        'category': 'Domain - Risk Level',
        'widget': 'Hardening Review - MacOS',
        'key': 'Risk Level',
        'is_editable': true
    },
    {
        'id': 20,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 1,
        'medium': 1,
        'high': 1,
        'critical': 0,
        'category': 'Domain - Risk Level',
        'widget': 'Hardening Review - Windows',
        'key': 'Risk Level',
        'is_editable': true
    },
    {
        'id': 21,
        'activity_id': 1,
        'other': 0,
        'informational': 0,
        'low': 7,
        'medium': 6,
        'high': 5,
        'critical': 0,
        'category': 'Domain - Risk Level',
        'widget': 'Architecture Review',
        'key': 'Risk Level',
        'is_editable': true
    },
    {
        'id': 23,
        'activity_id': 1,
        'other': 2,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Hardening Review - MacOS',
        'key': 'Network Security',
        'is_editable': true
    },
    {
        'id': 24,
        'activity_id': 1,
        'other': 1,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Hardening Review - MacOS',
        'key': 'Access Control',
        'is_editable': true
    },
    {
        'id': 25,
        'activity_id': 1,
        'other': 1,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Hardening Review - MacOS',
        'key': 'Monitoring and Logging',
        'is_editable': true
    },
    {
        'id': 28,
        'activity_id': 1,
        'other': 4,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Hardening Review - Windows',
        'key': 'Network Security',
        'is_editable': true
    },
    {
        'id': 29,
        'activity_id': 1,
        'other': 2,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Hardening Review - Windows',
        'key': 'Access Control',
        'is_editable': true
    },
    {
        'id': 30,
        'activity_id': 1,
        'other': 3,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Hardening Review - Windows',
        'key': 'Monitoring and Logging',
        'is_editable': true
    },
    {
        'id': 31,
        'activity_id': 1,
        'other': 1,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Hardening Review - Windows',
        'key': 'Data Protection',
        'is_editable': true
    },
    {
        'id': 32,
        'activity_id': 1,
        'other': 6,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Architecture Review',
        'key': 'Network Security',
        'is_editable': true
    },
    {
        'id': 33,
        'activity_id': 1,
        'other': 6,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Risk by Category',
        'widget': 'Architecture Review',
        'key': 'Monitoring and Logging',
        'is_editable': true
    },
    {
        'id': 35,
        'activity_id': 1,
        'other': 2,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Response',
        'widget': 'Hardening Review - MacOS',
        'key': 'Mitigate',
        'is_editable': true
    },
    {
        'id': 36,
        'activity_id': 1,
        'other': 1,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Response',
        'widget': 'Hardening Review - MacOS',
        'key': 'Transfer',
        'is_editable': true
    },
    {
        'id': 37,
        'activity_id': 1,
        'other': 2,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Response',
        'widget': 'Hardening Review - MacOS',
        'key': 'Accept',
        'is_editable': true
    },
    {
        'id': 39,
        'activity_id': 1,
        'other': 4,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Response',
        'widget': 'Hardening Review - Windows',
        'key': 'Mitigate',
        'is_editable': true
    },
    {
        'id': 40,
        'activity_id': 1,
        'other': 2,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Response',
        'widget': 'Hardening Review - Windows',
        'key': 'Transfer',
        'is_editable': true
    },
    {
        'id': 41,
        'activity_id': 1,
        'other': 3,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Response',
        'widget': 'Hardening Review - Windows',
        'key': 'Accept',
        'is_editable': true
    },
    {
        'id': 42,
        'activity_id': 1,
        'other': 6,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Response',
        'widget': 'Architecture Review',
        'key': 'Avoid',
        'is_editable': true
    },
    {
        'id': 43,
        'activity_id': 1,
        'other': 6,
        'informational': 0,
        'low': 0,
        'medium': 0,
        'high': 0,
        'critical': 0,
        'category': 'Domain - Response',
        'widget': 'Architecture Review',
        'key': 'Mitigate',
        'is_editable': true
    }
]

const START_FILLING_TEXT = 'Start filling out the activities to unlock the dashboard'

export {
    ddosActivityDemo,
    incidentResponseActivityDemo,
    phishingSimulationActivityDemo,
    ransomwareResilienceActivityDemo,
    ddosMetricsDemo,
    incidentResponseMetricsDemo,
    phishingSimulationMetricsDemo,
    ransomwareResilienceMetricsDemo,
    START_FILLING_TEXT,
    easmMetricsPlaceholder,
    qaMetricsPlaceholder,
    redTeamMetricsPlaceholder,
    penTestMetricsPlaceholder,
    ddosMetricsPlaceholder,
    riskAssessmentMetricsPlaceholder
}